import { Link } from "react-router-dom";

// Official MyRedPark logo (supplied asset). Dark variant for the dark UI;
// do not restyle or recolor — geometry is fixed by brand.
export default function Logo({ compact = false }) {
  return (
    <Link to="/" data-testid="logo-link" aria-label="MyRedPark home" className="flex items-center shrink-0">
      <img src="/brand/logo_dark.png" alt="MyRedPark — Your Spot. Your Way."
           className={compact ? "h-11 w-auto" : "h-12 w-auto"} />
    </Link>
  );
}
